var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"car-model-table section-card"},[_c('div',{staticClass:"section-title"},[_vm._v("选择租赁方案")]),_vm._v(" "),_c('base-list-management',{ref:"baseListRef",attrs:{"configData":_setup.configData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }